import studyPlanOverviewPageActionTypes from '../actions/study-plan-overview-page-action-types';

const initialState = {
  loading: false,
  studyPlan: null,
  studyPlanCancelToken: null,
  isConfirmDialogVisible: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case studyPlanOverviewPageActionTypes.LOAD_STUDY_PLAN_OVERVIEW_PAGE_START:
      return {
        ...state,
        loading: true
      };
    case studyPlanOverviewPageActionTypes.LOAD_STUDY_PLAN_OVERVIEW_PAGE_END:
      return {
        ...state,
        loading: false,
        studyPlan: action.payload
      };
    case studyPlanOverviewPageActionTypes.APPROVE_STUDY_PLAN_START:
      return {
        ...state,
        loading: true
      };
    case studyPlanOverviewPageActionTypes.APPROVE_STUDY_PLAN_END:
      return {
        ...state,
        loading: false,
        studyPlan: action.payload
      };
    case studyPlanOverviewPageActionTypes.APPROVE_STUDY_PLAN_START:
      return {
        ...state,
        loading: true
      };
    case studyPlanOverviewPageActionTypes.TOGGLE_CONFIRM_DIALOG:
      return {
        ...state,
        isConfirmDialogVisible: !state.isConfirmDialogVisible
      };
    case studyPlanOverviewPageActionTypes.DELETE_STUDY_PLAN_START:
      return {
        ...state,
        loading: true
      };
    case studyPlanOverviewPageActionTypes.DELETE_STUDY_PLAN_END:
      return {
        ...state,
        loading: false
      };
    case studyPlanOverviewPageActionTypes.APPROVE_STUDY_PLAN_END:
      return initialState;
    default:
      return state;
  }
};